





































































import { Component, Prop, Vue, Watch, Mixins, Emit } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import { ResHelper } from '@/helper/ResHelper';
import { ShoppingCart } from '@/entities/ShoppingCart';
import { UserHelper } from '@/helper/user';
import { ShoppingCartItem } from '@/entities/ShoppingCartItem';
import { DeleteIcon } from '@/components/icons/DeleteIcon';
import { SaveIcon } from '@/components/icons/SaveIcon';
import { MoveIcon } from '@/components/icons/MoveIcon';
import { CloseIcon } from '@/components/icons/CloseIcon';
import { ShoppingCartModuleTypes } from '@/store/modules/shopping-cart';

@Component({
    components: {
        DeleteIcon,
        SaveIcon,
        MoveIcon,
        CloseIcon,
    },
})
export default class ShoppingCartItemActions extends Mixins(BaseMixin) {
    @Prop(String)
    private unitCode!: string;
    @Prop(Number)
    private quantity!: number;
    @Prop(Number)
    private maxAllowedQuantity?: number;

    private currentQuantity: number = this.quantity;
    private editModeForMoveOfItemIsActive: boolean = false;
    private isUserAuthenticated: boolean = UserHelper.isAuthenticated();

    public get targetShoppingCarts(): ShoppingCart[] {
        const allCarts = this.$store.getters[ShoppingCartModuleTypes.getters.shoppingCarts] as ShoppingCart[];
        return allCarts.filter((cart) => cart.id !== this.activeShoppingCart.id);
    }

    public get activeShoppingCart(): ShoppingCart {
        return this.$store.getters[ShoppingCartModuleTypes.getters.activeShoppingCart];
    }

    public get showQuantitySaveButton(): boolean {
        return this.isQuantityValid && this.quantity !== this.currentQuantity;
    }

    public get isQuantityValid(): boolean {
        return (
            this.currentQuantity > 0 &&
            (this.maxAllowedQuantity === undefined || this.currentQuantity <= this.maxAllowedQuantity)
        );
    }

    @Watch('quantity')
    public quantityChanged(quantity: number): void {
        this.currentQuantity = quantity;
    }

    @Emit('delete-item')
    private deleteItem(): void {
        return;
    }

    private saveQuantityIfValid(): void {
        if (this.isQuantityValid) {
            this.saveQuantity();
        }
    }

    @Emit('save-quantity')
    private saveQuantity(): number {
        return this.currentQuantity;
    }

    private moveItemEditMode(): void {
        this.editModeForMoveOfItemIsActive = !this.editModeForMoveOfItemIsActive;
    }

    private targetShoppingCartSelectedForItemMove(event: Event): void {
        const selectedShoppingCartId = parseInt((event.target as HTMLSelectElement).value, 10);
        if (selectedShoppingCartId == null || isNaN(selectedShoppingCartId)) {
            return;
        }
        this.moveItem(selectedShoppingCartId);
    }

    @Emit('move-item')
    private moveItem(targetShoppingCartId: number): number {
        return targetShoppingCartId;
    }
}
